const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16,8A8,8,0,1,1,8,0,8,8,0,0,1,16,8ZM8.21,2.65A4.19,4.19,0,0,0,4.45,4.7a.39.39,0,0,0,.09.52l1.12.85A.38.38,0,0,0,6.2,6c.57-.73,1-1.15,1.84-1.15.66,0,1.48.42,1.48,1.06,0,.49-.4.73-1,1.1S6.71,8,6.71,9.29v.13a.38.38,0,0,0,.39.38H8.9a.38.38,0,0,0,.39-.38v0c0-.92,2.68-1,2.68-3.44,0-1.88-1.94-3.3-3.76-3.3Zm-.21,8a1.48,1.48,0,1,0,1.48,1.48h0A1.49,1.49,0,0,0,8,10.64Z",
    style: {
      fill: "#ccc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.61fe329b8fedfe4f355be77ff497e3ec.svg";
export { ForwardRef as ReactComponent };